<!-- The "if booted" makes his-header and his-footer wait for initialized uitexts and login information -->
@if (booted | async) {
  <div class="xhisng_wrapper">
    <his-notification></his-notification>
    @if (hisBaseGlobalsService.system.hisDevelopmentMode || hisBaseGlobalsService.system.operationMode === 'cust' ) {
      <his-page-option-panel></his-page-option-panel>
    }
    <his-breadcrumb></his-breadcrumb>
    <div class="maincontent"><!--  ui-g-12 -->
      <!-- Include content from app.component.html, e.g. router-outlet.                                -->
      <!-- Since ng-content and router-outlet ignore enclosing ngIf's, we need a resolve guard for it. -->
      <!-- That guard is registered for each route in app.module.ts                                    -->
      <ng-content select="*"></ng-content>
    </div>
  </div>
}
<his-httplistener></his-httplistener>
